export const ACCESS_TOKEN = 'accesstoken';
export const REFRESH_TOKEN = 'refreshtoken';